import clsx from "clsx"
import { Input, Spinner } from "../../utils/UtilComponents"
import { comparatorMap, rowSpanMap } from "./constants"
import { ThresholdCategoryData, Drafts } from "./types"

type ThresholdFormProps = {
    userThresholds: ThresholdCategoryData[]
    drafts: Drafts
    onParamChange: (catKey: string, paramKey: string, field: string, value: string) => void
    onSave: () => Promise<void>,
    loadState : boolean,
    updateState:boolean,

}

export const ThresholdForm = ({
  userThresholds,
  drafts,
  onParamChange,
  onSave,
  loadState,
  updateState
}: ThresholdFormProps) => {
    return(
        <>
            <div className="grid grid-cols-1 md:grid-cols-2 p-2 gap-2 w-full overflow-y-auto border rounded-lg border-[#94a3b8]">
                {userThresholds.map( category => {
                    const rowSpanClass = rowSpanMap[category.parameters.length] || "row-span-1";      
                    const draft = drafts[category.key];                    
                    return (
                        category.parameters.length > 0 &&
                        <div key={category.key} className={`flex h-auto flex-col gap-2 rounded-xl border border-[#94a3b8] bg-[#F8F8F8] p-4 shadow ${rowSpanClass}`}>
                            {
                                category.parameters.map(param => {
                                const paramDraft = draft?.params[param.key];
                                return (
                                    <div key={param.key} className='flex flex-col gap-1'>
                                        <p className="text-base text-[#1e293b] uppercase font-semibold">
                                            {param.label}
                                        </p>
                                        <div className="border border-[#94a3b8] rounded-xl">
                                            {/* Header */}
                                            <div className="flex items-center uppercase rounded-t-xl text-sm font-semibold text-[#1e293b] bg-[#cbd5e1]">
                                                <div className="flex flex-1 text-center text-[#1e293b] p-2 items-center justify-center gap-2">
                                                    <p>Marginal Risk</p>
                                                    <div className="w-3 h-3 rounded-full bg-yellow-300 border border-[#94a3b8]"/>
                                                </div>
                                                <div className="flex flex-1 text-center text-[#1e293b] p-2 items-center justify-center gap-2">
                                                    <p>High Risk</p>
                                                    <div className="w-3 h-3 rounded-full bg-red-600 border border-[#94a3b8]"/>
                                                </div>
                                            </div>
                                            {/* Static Param rows */}
                                            <div className="flex p-1 items-center gap-2 text-base text-[#1e293b]  divide-x divide-[#1e293b]">
                                                {/* Threshold input field */}
                                                <div className='flex flex-1 items-center'>
                                                    <div className='flex-1 text-center p-1 rounded-lg rounded-t-lg text-sm font-semibold text-[#64748B]'>
                                                        {comparatorMap[param.comparator]}
                                                    </div>
                                                    <div className="flex gap-2 text-center items-center w-[50%]">
                                                        <Input
                                                            placeHolder={'Threshold'}
                                                            type={'number'}
                                                            val={paramDraft?.currentMarginalRisk}
                                                            onChange={(v) => onParamChange(category.key, param.key, "currentMarginalRisk" , v)}
                                                            label={''}
                                                            tooltip={''}
                                                            edit = {true}
                                                        />
                                                        <p className="text-sm text-zinc-600 uppercase font-semibold bg-[#cbd5e1] p-1 rounded-lg border border-[#94a3b8] h-max">
                                                            {param.key == "precipitation" ? "%" : draft?.unit}
                                                        </p>
                                                    </div>
                                                </div>
                                                
                                                {/* Threshold input field */}
                                                <div className='flex flex-1 items-center'>
                                                    <div className='flex-1 text-center p-1 rounded-lg rounded-t-lg text-sm font-semibold text-[#64748B]'>
                                                        {comparatorMap[param.comparator]}
                                                    </div>
                                                    <div className="flex gap-2 text-center items-center w-[50%]">
                                                        <Input
                                                            placeHolder={'Threshold'}
                                                            type={'number'}
                                                            val={paramDraft?.currentHighRisk}
                                                            onChange={(v) => onParamChange(category.key, param.key, "currentHighRisk", v)}
                                                            label={''}
                                                            tooltip={''}
                                                            edit = {true}
                                                        />
                                                        <p className="text-sm text-zinc-600 uppercase font-semibold bg-[#cbd5e1] p-1 rounded-lg border border-[#94a3b8] h-max">
                                                            {param.key == "precipitation" ? "%" : draft?.unit}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )})
                            }
                        </div>
                    );
                })}
            </div>
            <div className="flex items-center justify-center">
                <button
                    onClick={() => onSave()}
                    className={clsx(`w-1/2 font-semibold p-2
                    text-base uppercase rounded border border-inset border-[#346F3E]
                    transition duration-150`,
                    updateState ? "bg-[#FCF9C1] text-[#895B1A] hover:bg-yellow-200" : "bg-[#DFFCE6] text-green-900 hover:bg-green-200")}
                    disabled={loadState}
                >
                    {loadState ? <Spinner/> : <span>Save Thresholds</span>}
                </button>
            </div>
        </>
    )
}